export default __webpack_public_path__ + "static/media/NFO_PostLogin_MidSmall_Finacial_Services_Hero_desktop.29bd0ec2.jpg";